import React from "react";
import { actorCanAccessGoogleVisibility } from "../../helpers/googleVisibilityAccess";
import "./GoogleVisibilityScreen.css";

export function GoogleVisibilityEntryCard({ actor, onOpen }) {
  if (!actorCanAccessGoogleVisibility(actor)) {
    return null;
  }

  return (
    <button
      type="button"
      className="gvis-entry-card"
      onClick={onOpen}
      data-testid="google-visibility-entry"
    >
      <span className="gvis-entry-copy">
        <span className="gvis-kicker">Surface Renaud</span>
        <span className="gvis-entry-title">Google Visibility</span>
        <span className="gvis-entry-meta">GBP, Search Console, local SEO</span>
      </span>
      <span className="gvis-entry-open">Open</span>
    </button>
  );
}
